<template>
  <div class="imeiDetail">
    <nut-navbar @on-click-back="back" :rightShow="false">我的设备</nut-navbar>
    <div class="BgCar">
      <img src="" alt="" /><img src="../assets/images/bcBgm.png" alt="" />
    </div>
    <div class="contentNew">
      <div class="content">
        <div class="dingwei" @click="to_dingwei()">点这里，查看车辆定位</div>
        <div class="detailNew">
          <div class="detail flex">
            <div class="left">
              <div class="leftTop">imei号</div>
              <img src="../assets/images/sim3.png" class="img" />
            </div>
            <div class="right">
              <div style="font-weight: bold; color: #008657" class="leftBottom">
                {{ detail.imei }}
              </div>
            </div>
          </div>
          <div class="detail flex">
            <div class="left">
              <div class="leftTop">车牌号</div>
              <img src="../assets/images/zu.png" class="img" />
            </div>
            <div class="right">
              <div class="leftBottom">{{ detail.lasttruck }}</div>
            </div>
          </div>
        </div>
        <div class="details">
          <div class="left flex">
            <div class="leftTop">GPS有效期</div>
            <div class="leftBottom" style="font-size: 15px;">
              {{ detail.begin_date }}至{{ detail.end_date }}
            </div>
          </div>
          <div class="right flex">
            <img src="../assets/images/time2.png" class="img" />
            <div class="leftDay">
              <!-- 剩余天数：{{ leftDay }}天<span>（以设备出货日+7天为起始日）</span> -->
            </div>
          </div>
        </div>
      </div>
      <div v-show="false" v-html="fukuan"></div>
      <div class="chongzhi">
        <div class="inner">
          <div class="title">微信在线充值</div>
          <div class="mainCZ">
            <div class="row flex">
              <div class="label">充值GPS编码：{{ detail.sim_no }}</div>
              <input class="input" type="text" :value="detail.imei" readonly="readonly" />
            </div>
            <div class="row">
              <div class="half-row flex" style="margin-top: 40px;">
                <div class="labels">有效期<span>1年</span></div>
              </div>
              <div class="half-row flex">
                <div class="label">充值金额:</div>
                <div class="frame">
                  <span class="kuang"> 65元 </span>
                </div>
              </div>
            </div>
            <div class="row flex">
              <div class="label">总金额：</div>
              <div class="text">65元</div>
            </div>
            <button class="submitBtn" @click="chongzhi()">立即充值</button>
          </div>
        </div>
      </div>
      <div class="czRecord">
        <div style="margin-bottom: -10%; padding-top: 5%; margin-left: 4%" class="title">
          充值记录
        </div>
        <div ref="table" v-if="tableData" class="inner">
          <div v-for="(item, index) in tableData" :key="index" class="tableWrap">
            <div class="tableNew">
              <div class="tableItem">{{ item.Date }}</div>
              <div class="tableItem">已完成</div>
            </div>
            <div class="tableConte">
              <div class="tableContes">
                <div class="tableLoge">
                  <img src="../assets/images/money.png" alt="" />
                </div>
                <div class="wxRge">
                  <div class="wxRgeitem">微信充值</div>
                  <div class="wxRgetext">订单号：{{ tableData.trade_no }}</div>
                </div>
              </div>
              <div class="wxMye">
                <div class="Total">{{ item.pay_money }}元</div>
                <div class="Actual">实付金额¥{{ item.pay_money }}</div>
              </div>
            </div>
            <el-divider></el-divider>
          </div>
        </div>
        <div style="margin-left: 37%;  margin-top: 10%;  width: 100%; font-weight: 700;" ref="table" v-else class="inner">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import preventBack from "vue-prevent-browser-back";
import qs from "qs";
export default {
  mixins: [preventBack], //阻止返回上一页
  data() {
    return {
      detail: {},
      fukuan: "",
      leftDay: 0,
      tableData: null,
      code: "",
      // url: "http://192.168.88.80:8011/",
      url: "http://www.bd-gps.com/bdgps/",
      // url:"http://chaxun.kcbdgps.com/bdgps/",
      // url: "http://192.168.88.211:8875/",
      imei: "",
    };
  },
  methods: {
    back() {
      this.$router.push({
        name: "login",
      });
    },
    chongzhi() {
      this.$axios
        .get(this.url + "api/WePay/GetPay", {
          params: {
            imei: this.detail.imei,
            totalfee: 65,
            code: this.code,
          },
        })
        .then((res) => {
          if (res.data.result == "success") {
            this.fCharge(res.data.Data);
          } else {
            this.$dialog({
              id: "my-dialog",
              title: "提示！",
              content: res.data.Message,
              noOkBtn: true,
              cancelBtnTxt: "我知道了",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onBridgeReady(json) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: json.appId, //公众号名称，由商户传入
          timeStamp: json.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: json.nonceStr, //随机串
          package: json.packageValue,
          signType: "MD5", //微信签名方式:
          paySign: json.paySign, //微信签名
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            alert("支付成功,请稍后查询余额,如有疑问,请联系管理员.");
            this.getczRecord();
            // fAlreadyPay();
          } // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
        }
      );
    },
    getczRecord() {
      this.$axios
        .get(this.url + "api/GPS/GetGPSDateList?validateCode=0000", {
          params: {
            imei: this.detail.imei,
          },
        })
        .then((res) => {
          console.log(res.data, ">>>>");
          this.tableData = res.data.Data.Rows;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    datedifference() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      console.log(dateSpan);
      var sDate1 = Date.parse(currentdate);
      var sDate2 = Date.parse(this.detail.end_date);
      var dateSpan = sDate2 - sDate1;
      console.log(dateSpan);
      dateSpan = Math.abs(dateSpan);
      var iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      this.leftDay = iDays;
    },
    submit() {
      this.chongzhi();
    },
    to_dingwei() {
      this.$router.push({
        name: "maps",
        params: {
          imei: this.detail.imei,
          fromtype: this.detail.fromtype,
        },
      });
    },
    versions() {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        trident: u.indexOf("Trident") > -1, //IE内核
        presto: u.indexOf("Presto") > -1, //opera内核
        webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
        iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, //是否iPad
        webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
      };
    },
    fCharge(data) {
      var that = this;
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          console.log("走1");
          document.addEventListener(
            "WeixinJSBridgeReady",
            that.onBridgeReady(data),
            false
          );
        } else if (document.attachEvent) {
          console.log("走2");
          document.attachEvent("WeixinJSBridgeReady", that.onBridgeReady(data));
          document.attachEvent(
            "onWeixinJSBridgeReady",
            that.onBridgeReady(data)
          );
        }
      } else {
        console.log("走3");
        that.onBridgeReady(data);
      }
    },
    yanzheng() {
      this.$axios
        .get(this.url + "api/WePay/GetCode", {
          params: {
            type: "detail",
            imei: this.imei,
          },
        })
        .then((res) => {
          // console.error(res.data,">>>>>")
          if (res.data.result == "success") {
            var data = res.data.Data;
            console.log(res.data.Data);
            window.location = res.data.Data;
          } else {
            this.$dialog({
              id: "my-dialog",
              title: "提示！",
              content: res.data.Message,
              noOkBtn: true,
              cancelBtnTxt: "我知道了",
            });
          }
        })
        .catch((error) => {
          this.loading.hide();
          console.log(error);
        });
    },
    GetRequest() {
      var url = window.location.search;
      //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        let str = url.substr(1);
        let strs = str.split("&");
        console.log(strs, './././');
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    toDetail(imei) {
      console.error(imei);
      this.loading = this.$toast.loading("请稍等", {
        coverColor: "rgba(0,0,0,0.5)",
      });
      this.$axios
        .get(this.url + "api/GPS/GetGPSDate", {
          params: {
            imei: imei,
          },
        })
        .then((res) => {
          this.loading.hide();
          if (res.data.result == "success") {
            this.detail = res.data.Data.Rows[0];
            this.datedifference();
            this.getczRecord();
          } else {
            this.$dialog({
              id: "my-dialog",
              title: "提示！",
              content: res.data.Message,
              noOkBtn: true,
              cancelBtnTxt: "我知道了",
            });
          }
          console.log(res,'res');
        })
        .catch((error) => {
          this.loading.hide();
          console.log(error);
        });
    },
  },
  mounted() {
    console.log(this.$route.params);
    var dizhi = this.GetRequest();
    console.log("location", window.location);
    console.log("dizhi", JSON.stringify(dizhi));
    this.code = this.$route.params.code;
    if (window.location.href.indexOf("imei=") != -1) {
      this.code = dizhi.code;
      var index = window.location.href.indexOf("imei=");
      var jiequ = window.location.href.substr(
        index,
        window.location.href.length
      );
      console.log("jiequ", jiequ);
      jiequ = jiequ.split("=");
      this.imei = jiequ[1];
      this.toDetail(this.imei);
    } else {
      if (this.$route.params.detail) {
        //如果是查询进来走这边
        this.detail = this.$route.params.detail.Rows[0];
        console.log(this.detail,'this.detail');
        this.datedifference();
        this.getczRecord();
      } else {
        if (this.$route.params.imei) {
          //如果是我的列表和绑定进来的时候走这边重新获取code
          this.imei = this.$route.params.imei;
          this.yanzheng();
        } else {
          this.detail = JSON.parse(localStorage.getItem("imeiDetail")).Rows[0];
          console.log(this.detail,'this.detail111');
          this.datedifference();
          this.getczRecord();
        }
      }
    }

    console.log(JSON.stringify(this.versions()));
    if (this.versions().ios || this.versions().iPhone || this.versions().iPad) {
      //如果是ios系统
      console.log("ios");
    } else if (this.versions().android) {
      //如果是Android系统 就
      console.log("Android");
    }
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      console.log("这是微信");
    } else {
    }
  },
};
</script>
  
<style scoped>
.imeiDetail {
  width: 100%;
  height: 100%;
  background-color: #f7f7f7;
  overflow: auto;
  position: relative;
}

.imeiDetail .BgCar {
  width: 100%;
  height: 100%;
  opacity: 0.8;
  /* background-color: #00ae71; */
  position: absolute;
}

.imeiDetail .BgCar img {
  width: 100%;
}

.imeiDetail .contentNew {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  position: absolute;
  top: 280px;
  width: 100%;
  background-color: #f7f7f7;
}

.imeiDetail .content .detailNew {
  box-shadow: 0 0px 0 #e5e5e5, 0 0 15px rgba(0, 0, 0, 0.12),
    0 2px 4px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  width: 90%;
  margin-left: 5%;
}

.imeiDetail .content .details {
  /* height: 74px; */
  box-shadow: 0 0px 0 #e5e5e5, 0 0 15px rgba(0, 0, 0, 0.12),
    0 2px 4px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  width: 85%;
  margin-left: 5%;
  margin-top: 20px;
  padding: 10px;
}

.imeiDetail .content .details .leftTop {
  margin-left: 8px;
}

.imeiDetail .content .details img {
  width: 50px;
  height: 50px;
}

.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.imeiDetail .content .detail .left {
  /* width: calc(70% - 20px); */
  /* width: -webkit-calc(70% - 20px); */
  width: -moz-calc(70% - 20px);
  /* height: 100px; */
  padding-left: 20px;
}

.imeiDetail .content .detail .left .leftTop {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  text-transform: uppercase;
  color: #8898aa;
  font-weight: 600;
}

.imeiDetail .content .detail .left .leftBottom {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: #525252;
  font-weight: 600;
}

.imeiDetail .content .details .right .leftDay {
  font-size: 13px;
  color: #666666;
  /* line-height: 20%; */
  align-self: center;
  margin-left: 5px;
}

.imeiDetail .content .details .right {
  margin-top: 10px;
}

.imeiDetail .content .details .left .leftBottom {
  color: #ff7e00;
  font-size: 13px;
  line-height: 23px;
  margin-left: 5px;
}

.imeiDetail .content .detail .right {
  width: 100%;
  height: 30px;
  line-height: 30px;
  position: relative;
  top: 35px;
  left: 5px;
  color: #00ae71;
  letter-spacing: 2px;
}

.imeiDetail .content .detail .left .img {
  width: 70px;
  /* height: 90px; */
  /* position: absolute;
      top: 50%;
      left: 50%; */
  /* margin-top: -35px;
      margin-left: -35px; */
}

.imeiDetail .chongzhi {
  width: 90%;
  height: 300px;
  background-color: #fff;
  box-shadow: 0 0px 0 #e5e5e5, 0 0 15px rgba(0, 0, 0, 0.12),
    0 2px 4px rgba(0, 0, 0, 0.05);
  margin-left: 5%;
  /* border-radius: 15px; */
  margin-top: 20px;
}

.imeiDetail .czRecord {
  width: 90%;
  /* height: 300px; */
  background-color: #fff;
  box-shadow: 0 0px 0 #e5e5e5, 0 0 15px rgba(0, 0, 0, 0.12),
    0 2px 4px rgba(0, 0, 0, 0.05);
  margin-left: 5%;
  /* border-radius: 15px; */
  margin-top: 20px;
}

.imeiDetail .chongzhi .inner {
  padding: 34px 16px;
  width: -webkit-calc(100% - 32px);
  width: -moz-calc(100% - 32px);
  width: calc(100% - 32px);
  height: 252px;
}

.imeiDetail .chongzhi .inner .title {
  /* font-weight: 700; */
  font-size: 17px;
  /* color: #333333; */
  margin: 0px 0px 10px 0px;
  text-align: left;
}

.imeiDetail .czRecord .inner {
  padding: 24px 16px;
  width: -webkit-calc(100% - 32px);
  width: -moz-calc(100% - 32px);
  width: calc(100% - 32px);
  /* height: 252px; */
}

.imeiDetail .czRecord .inner .title {
  margin: 0px 0px 10px 0px;
  text-align: left;
}

.imeiDetail .czRecord .tableWrap {
  width: 100%;
  /* height: 201px; */
}

.imeiDetail .czRecord .tableWrap .tableNew .tableItem {
  color: #666666;
  font-size: 13px;
}

.imeiDetail .czRecord .tableWrap .tableConte {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.imeiDetail .czRecord .tableWrap .tableConte .tableContes {
  display: flex;
}

.imeiDetail .czRecord .tableWrap .tableNew {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.imeiDetail .czRecord .tableWrap .tableNew .tableItem {
  margin: 10px 0px;
}

.imeiDetail .czRecord .tableWrap .tableConte img {
  width: 40px;
  height: 40px;
  margin-right: 15px;
}

.imeiDetail .czRecord .tableWrap .tableConte .wxMye .Total {
  padding-left: 58px;
  color: #00ae71;
  margin: 3px 0px;
}

.imeiDetail .czRecord .tableWrap .tableConte .wxMye .Actual {
  color: #999999;
  font-size: 13px;
}

.imeiDetail .czRecord .tableWrap .tableConte .wxRge .wxRgeitem {
  font-size: 14px;
  color: #333333;
}

.imeiDetail .czRecord .tableWrap .tableConte .wxRge .wxRgetext {
  color: #666666;
  font-size: 13px;
  margin-top: 6px;
}

.imeiDetail .chongzhi .inner .mainCZ {
  width: 100%;
  height: 201px;
  margin: auto;
}

.imeiDetail .chongzhi .inner .mainCZ .row {
  height: auto;
  width: 100%;
  margin-bottom: 10px;
}

.imeiDetail .chongzhi .inner .mainCZ .row .label {
  width: 100px;
  height: 32px;
  line-height: 32px;
  text-align: left;
  color: #666666;
  font-size: 14px;
}

.imeiDetail .chongzhi .inner .mainCZ .row .input {
  width: calc(100% - 116px);
  width: -webkit-calc(100% - 116px);
  width: -moz-calc(100% - 116px);
  height: 22px;
  text-align: left;
  color: #666666;
  font-size: 14px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding: 4px 0px 4px 14px;
  font-weight: 600;
}

.imeiDetail .chongzhi .inner .mainCZ .row .half-row {
  width: 100%;
  margin-bottom: 10px;
}

.imeiDetail .chongzhi .inner .mainCZ .row .half-row .labels {
  color: #ff7e00;
  font-size: 13px;
}

.imeiDetail .chongzhi .inner .mainCZ .row .half-row .text,
.frame {
  width: calc(100% - 100px);
  width: -webkit-calc(100% - 100px);
  width: -moz-calc(100% - 100px);
  color: #ff6700;
  height: 32px;
  line-height: 32px;
  font-weight: 700;
}

.imeiDetail .chongzhi .inner .mainCZ .row .half-row .frame .kuang {
  display: inline-block;
  width: 100px;
  height: 28px;
  line-height: 28px;
  /* border: 2px solid #ff6700; */
  background-color: #00ae71;
  color: #ffffff;
  text-align: center;
  position: relative;
}

/* .imeiDetail .chongzhi .inner .mainCZ .row .half-row .frame .kuang::after {
      position: absolute;
      display: block;
      right: 0px;
      bottom: 0px;
      width: 0;
      height: 0;
      border-bottom: 15px solid #ff6700;
      border-left: 15px solid transparent;
      content: "";
  } */

.imeiDetail .chongzhi .inner .mainCZ .row .text {
  /* width: calc(100% - 100px);
      width: -webkit-calc(100% - 100px);
      width: -moz-calc(100% - 100px); */
  height: 32px;
  line-height: 32px;
  color: #00ae71;
  font-weight: 700;
}

.imeiDetail .chongzhi .inner .mainCZ .submitBtn {
  /* height: 32px; */
  width: 90%;
  margin: 0px;
  padding: 0px;
  background-color: #00ae71;
  border-radius: 5px;
  color: #ffffff;
  border: none;
  margin-left: 5%;
  font-weight: 600;
  line-height: 40px;
}

.imeiDetail .dingwei {
  margin: 40px 40px;
  font-size: 15px;
  background-color: #00ae71;
  text-align: center;
  line-height: 50px;
  box-shadow: 0px 3px 39px 4px rgba(0, 215, 140, 0.4);
  border-radius: 69px;
  color: #ffffff;
  /* text-decoration: underline; */
  cursor: pointer;
}

@media screen and (min-width: 1080px) {
  .imeiDetail .content {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .imeiDetail .content .detail {
    width: 30%;
    height: 100px;
    background-color: #fff;
    box-shadow: 0 0px 0 #e5e5e5, 0 0 15px rgba(0, 0, 0, 0.12),
      0 2px 4px rgba(0, 0, 0, 0.05);
    margin-left: 2.5%;
    border-radius: 15px;
    margin-top: 20px;
  }

  .imeiDetail .chongzhi {
    width: 95%;
    height: 300px;
    background-color: #fff;
    box-shadow: 0 0px 0 #e5e5e5, 0 0 15px rgba(0, 0, 0, 0.12),
      0 2px 4px rgba(0, 0, 0, 0.05);
    margin-left: 2.5%;
    border-radius: 15px;
    margin-top: 20px;
  }

  .imeiDetail .czRecord {
    width: 95%;
    height: 300px;
    background-color: #fff;
    box-shadow: 0 0px 0 #e5e5e5, 0 0 15px rgba(0, 0, 0, 0.12),
      0 2px 4px rgba(0, 0, 0, 0.05);
    margin-left: 2.5%;
    border-radius: 15px;
    margin-top: 20px;
  }

  .imeiDetail .chongzhi .inner .mainCZ {
    width: 600px;
    height: 201px;
    margin: auto;
  }

  .imeiDetail .chongzhi .inner .mainCZ .row {
    height: 40px;
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .imeiDetail .chongzhi .inner .mainCZ .row .label {
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: left;
    color: #666666;
    font-size: 16px;
  }

  .imeiDetail .chongzhi .inner .mainCZ .row .input {
    width: 444px;
    height: 22px;
    text-align: left;
    color: #666666;
    font-size: 18px;
    border: 1px solid #cccccc;
    border-radius: 15px;
    padding: 8px 0px 8px 16px;
    font-weight: 600;
  }

  .imeiDetail .chongzhi .inner .mainCZ .row .text {
    width: 444px;
    height: 40px;
    line-height: 40px;
    color: #ff6700;
    font-weight: 700;
  }

  .imeiDetail .chongzhi .inner .mainCZ .row .half-row {
    width: 300px;
    margin-bottom: 10px;
    height: 40px;
  }

  .imeiDetail .chongzhi .inner .mainCZ .row .half-row .text,
  .frame {
    width: 150px;
    color: #ff6700;
    height: 40px;
    line-height: 40px;
    font-weight: 700;
  }

  .imeiDetail .chongzhi .inner .mainCZ .row .half-row .frame .kuang {
    display: inline-block;
    width: 100px;
    height: 36px;
    line-height: 36px;
    border: 2px solid #ff6700;
    text-align: center;
    position: relative;
  }

  .imeiDetail .chongzhi .inner .mainCZ .row .half-row .frame .kuang::after {
    position: absolute;
    display: block;
    right: 0px;
    bottom: 0px;
    width: 0;
    height: 0;
    border-bottom: 15px solid #ff6700;
    border-left: 15px solid transparent;
    content: "";
  }

  .imeiDetail .chongzhi .inner .mainCZ .submitBtn {
    height: 32px;
    width: 180px;
    margin: 0px 210px;
    border-radius: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/imeiDetail.vue